var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DxDateBox',{attrs:{"value":_vm.date,"display-format":"dd MMM yyyy","readOnly":_vm.readOnly,"max":_vm.maxDate},on:{"valueChanged":_vm.onValueChange,"key-down":_vm.onKeyDown}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }